import axios from '@/utils/axios'
import myAxios from '@/utils/myAxios'

// 主播直播列表
export function getLiveList({ pageNo, pageSize }) {
  return axios.get(`/live/getLiveList`, {
    params: {
      pageNo,
      pageSize
    }
  })
}

// 获取预告详情
export function foreshow({ liveId, token, code }) {
  return axios.get(`/live/foreshow`, {
    params: {
      liveId,
      token,
      code
    }
  })
}

// 获取直播详情
export function getLiveDetail({ liveId, userType, token, code }) {
  return axios.get(`/live/liveDetail`, {
    params: {
      liveId,
      userType,
      token,
      code
    }
  })
}

// 开播提醒
export function remind({liveId, token}) {
  return axios.post(`/live/remind?liveId=${liveId}&token=${token}`)
}

// 关注/取关频道
export function starChannel({channelId, isStar, token, openId, liveId, type}) {
  return axios.post(`/live/starChannel?channelId=${channelId}&isStar=${isStar}&token=${token}&openId=${openId}&liveId=${liveId}&type=${type}`)
}

// 获取直播评论
export function getCommentList(params) {
  return axios.get(`/commonComment/getCommentList`, {params})
}

// 获取回放列表
export function getReplayList(params) {
  return axios.get(`/liveRecorded/replayPage`, {params})
}

// 获取合集列表
export function getCollectionList(collectionId) {
  return axios.get(`/live/collectionLives?collectionId=${collectionId}`)
}

// 获取回放详情
export function getReplayDetails(params) {
  return axios.get(`/liveRecorded/replayDetail`, {params})
}

// 分享统计
export function shareStatistics({liveId, type}) {
  return axios.post(`/live/shareStatistics?liveId=${liveId}&type=${type}`)
}

// 绑定分享关系
export function shareBind({token, bindUserId, userId, liveId, type}) {
  return myAxios.post(`/live/liveShareBind?liveId=${liveId}&token=${token}&userId=${userId}&bindUserId=${bindUserId}&type=${type}`)
}

// 获取解锁任务
export function getUnlockTask(params) {
  return axios.get(`/live/getUnlockTask`, {params})
}
